import { atom, useAtom } from "jotai";
import { TableOfContentsItem } from "pages/notebooks/notebook-reference-panel/bookview/use-virtual-table-of-contents";
import { useCallback } from "react";
import PublicationComponentType from "utilities/enumerations/publication-component-type";

const OpenTocPanelAtom = atom<string[]>([]);

export const useOpenTocPanels = () => {
    const [openPanels, setOpenPanels] = useAtom(OpenTocPanelAtom);
    const onOpenPanel = (
        id: number,
        publicationComponentType: PublicationComponentType
    ) => {
        const key = `${id}_${publicationComponentType}`;
        setOpenPanels((prev) => (prev.includes(key) ? prev : [...prev, key]));
    };

    const onClosePanel = (
        id: number,
        publicationComponentType: PublicationComponentType
    ) => {
        setOpenPanels((prev) =>
            prev.filter(
                (prevId) => prevId !== `${id}_${publicationComponentType}`
            )
        );
    };

    const resetAllPanels = () => {
        setOpenPanels([]);
    };

    const openPreviousPanel = (prevTocItems: TableOfContentsItem[]) => {
        const itemsToOpen = prevTocItems.map(
            (prevTocItem) =>
                `${prevTocItem?.id}_${prevTocItem?.publicationType}`
        );
        setOpenPanels([...itemsToOpen]);
    };

    const isPanelCollapsed = useCallback(
        (
            idToCheck: number,
            publicationComponentType: PublicationComponentType
        ) => {
            return !openPanels.includes(
                `${idToCheck}_${publicationComponentType}`
            );
        },
        [openPanels]
    );

    return {
        openPanels,
        openPreviousPanel,
        onOpenPanel,
        onClosePanel,
        resetAllPanels,
        isPanelCollapsed,
    };
};
